export const fixoRegex = /^\d{2}[2-5]\d{7}$/;
